export default {
    header: {
        telefone: "Téléphone",
        signIn: "Se connecter",
        register: "S'inscrire",
        becomeExpert: "Enregistrer votre entreprise",
        dashboard: "Tableau de bord",

        sidebar: {
            tuktuk: {
                title: "Tuk Tuk",
                subtitle: "Réservation de Tuk Tuk",
                menu: {
                    grid: "Liste des Tuk Tuk",
                },
            },
            about: {
                title: "À propos",
                subtitle: "À propos",
                menu: {
                    aboutUs: "À propos de nous",
                    testimonials: "Témoignages",
                    faq: "Foire aux questions",
                    contact: "Contactez-nous",
                    terms: "Termes et Conditions",
                    privacy: "Politique de confidentialité",
                },
            },
            dashboard: {
                title: "Tableau de bord",
                subtitle: "Tableau de bord utilisateur",
                subtitle2: "Tableau de bord agent",
                menu: {
                    dashboard: "Tableau de bord",
                    myBookings: "Mes réservations",
                    reviews: "Évaluations",
                    support: "Assistance",
                    wishlist: "Liste de souhaits",
                    wallet: "Portefeuille",
                    profileSettings: "Paramètres de profil",
                    notifications: "Notifications",
                    myProfile: "Mon profil",
                    settings: "Paramètres",
                    dashboard2: "Tableau de bord",
                    bookings: "Réservations",
                    enquiries: "Demandes",
                    earnings: "Gains",
                    reviews2: "Évaluations",
                    settings2: "Paramètres",
                },
            },
            social: {
                title: "Réseau Social",
                subtitle: "Fil de publications",
                menu: {
                    feed: "Fil d'actualité",
                    myProfilePage: "Ma page de profil",
                    explore: "Explorer",
                },
            },
        },
    },

    common: {
        welcome: "Bienvenue, {{name}}!",
    },

    home: {
        hero: {
            title: "Rapprochez-vous du rêve :",
            title2: "l'essentiel de votre voyage vous attend",
            title3: "vous",
            subtitle: "Votre destination ultime pour tout ce qui aide à célébrer et à vous souvenir de votre expérience de voyage.",
            tukTuk: "Tuk Tuk",
        },
        searchBy: {
            titlePrefix: "Forfaits",
            titleSuffix: "récents",
            subtitle:
                "Découvrez les derniers forfaits ajoutés à Portugalwaytour et explorez des opportunités de voyage uniques soigneusement sélectionnées pour vous offrir des expériences inoubliables, de nouvelles destinations et des aventures exclusives partout dans le monde.",
            noPackages: "Aucun forfait récent trouvé.",
            hasDiferencial: "A un avantage",
            noReviews: "Aucune évaluation",
            viewAll: "Voir tous les forfaits",
        },
        sectionBenefit: {
            titlePrefix: "Nos",
            titleHighlight: "Avantages",
            titleSuffix: "et principaux atouts",
            subtitle:
                "Portugalway, un tour-opérateur spécialisé dans les destinations de rêve, offre une variété d'avantages aux voyageurs.",
            benefits: [
                {
                    title: "Expériences authentiques",
                    description:
                        "Évadez-vous du tourisme traditionnel et découvrez le Portugal authentique ! Nos excursions offrent des expériences genuines en explorant la culture locale, la cuisine et des lieux secrets.",
                },
                {
                    title: "Forfaits de voyage personnalisés",
                    description:
                        "Créez votre voyage sur mesure ! Choisissez votre expérience et nous nous occupons de tout : hébergement, transport et activités, pour un voyage personnalisé et inoubliable.",
                },
                {
                    title: "Confort et Sécurité",
                    description:
                        "Nous nous occupons de tous les détails : transport confortable, hébergement sélectionné et accompagnement de guides professionnels, garantissant la tranquillité du début à la fin du voyage.",
                },
                {
                    title: "Service Dédié",
                    description:
                        "Du premier contact jusqu'au retour de votre voyage, vous bénéficiez d'un support personnalisé et d'une équipe prête à répondre en portugais et en anglais, avec rapidité et une attention totale à vos besoins.",
                },
            ],
        },
        exploreCities: {
            title: "Explorer par ville",
            subtitle: "Découvrez des expériences uniques dans des destinations incroyables",
        },
        placeSection: {
            titlePrefix: "Forfaits",
            titleHighlight: "en vogue",
            subtitle:
                "Explorez nos forfaits de voyage les plus populaires, soigneusement sélectionnés pour leurs notes élevées, leurs avis positifs et leurs réservations fréquentes par d'autres voyageurs. Trouvez votre prochaine aventure inoubliable ici.",
            all: "Tous",
            hasDiferencial: "A un avantage",
            noReviews: "Aucune évaluation",
            viewAll: "Voir tous les forfaits",
        },
        aboutSection: {
            welcome: "Bienvenue à Portugalwaytour",
            title: "Explorez au-delà de l'horizon : découvrez les merveilles du monde",
            description1: "Chez Portugal Way Tour, nous croyons que voyager est une transformation. Nous sommes une agence spécialisée dans les expériences touristiques uniques au Portugal, engagée à révéler le meilleur du pays — sa culture, ses paysages, son histoire et son authenticité.",
            point1: "Offrir des voyages mémorables, avec confort, sécurité et enchantement. Nous voulons que chaque touriste découvre le Portugal en profondeur, avec des itinéraires qui mêlent tradition, nature, gastronomie et hospitalité authentique.",
            point2: "Être une référence de qualité et de confiance dans le tourisme au Portugal, reconnue par les touristes du monde entier comme synonyme de professionnalisme et d'enchantement.",
            learnMore: "En savoir plus",
            reviews: "{{count}}+ Évaluations"
        },
        aboutCounters: [
            { label: "Destinations dans le Monde", icon: "isax-global5", colorClass: "text-teal" },
            { label: "Réservations Terminées", icon: "isax-calendar-2", colorClass: "text-purple" },
            { label: "Clients dans le Monde", icon: "isax-tag-user5", colorClass: "text-pink" },
            { label: "Fournisseurs Enregistrés", icon: "isax-status-up5", colorClass: "text-info" },
        ],
        expertSection: {
            popularTitle: "Populaires",
            popularSubtitle: "Découvrez les services les plus populaires, bien évalués et fréquemment réservés par les voyageurs.",
            serviceName: "Chauffeur de Tuk Tuk",
            loading: "Chargement...",
            reservationsSingular: "réservation",
            reservationsPlural: "réservations",
            viewProfile: "Voir le profil",
            viewAll: "Voir tout",
        },
        driverModal: {
            loading: "Chargement...",
            description: "Description",
            languages: "Langues",
            vehicle: "Véhicule",
            seats: "sièges",
            averageRating: "Évaluation moyenne",
            reviews: "Évaluations",
            packages: "Forfaits",
            noReviews: "Aucune évaluation pour l'instant",
            noPackages: "Ce chauffeur n'a pas de forfaits enregistrés"
        },
        testimonialSection: {
            title: "Ce que disent nos {{highlight}}",
            highlight: "utilisateurs",
            subtitle: "Découvrez ce que nos voyageurs ont pensé de leurs expériences.",
            loading: "Chargement des évaluations...",
            noReviews: "Aucune évaluation trouvée.",
            noComment: "L'utilisateur n'a pas laissé de commentaire.",
            viewPackage: "Voir les détails du forfait"
        },
        updateSection: {
            faq: {
                title: "Questions {{highlight}}",
                highlight: "Fréquentes",
                subtitle: "Portugalway, un opérateur de tourisme spécialisé dans les destinations de rêve, offre une variété d'avantages aux voyageurs.",
                questions: [
                    {
                        question: "Comment puis-je réserver un tour ?",
                        answer: "Vous pouvez réserver directement sur notre site web ou nous contacter par e-mail ou téléphone. Après avoir défini l'itinéraire souhaité, nous vous fournirons un devis, confirmerons les hôtels et services, et demanderons le paiement conformément à la politique indiquée."
                    },
                    {
                        question: "Est-il possible de personnaliser l'itinéraire ?",
                        answer: "Oui ! Tous nos itinéraires sont flexibles. Vous choisissez les lieux que vous souhaitez visiter, la durée, le type d'hébergement et, dans la mesure du possible, nous créons quelque chose qui correspond à votre profil."
                    },
                    {
                        question: "Quelles sont les langues parlées par les guides ?",
                        answer: "Nous avons des guides qui parlent portugais, anglais et, selon le tour, d'autres langues. Veuillez nous informer de vos préférences lors de la réservation afin que nous puissions attribuer le guide le plus approprié."
                    },
                    {
                        question: "Quelle est la politique d'annulation ?",
                        answer: "Nous avons une politique d'annulation qui varie en fonction du tour, de l'avance et des fournisseurs. Au moment de la réservation, nous vous enverrons les conditions complètes. Nous vous demandons de les lire attentivement avant de confirmer."
                    },
                    {
                        question: "Quels sont les modes de paiement acceptés ?",
                        answer: "Nous acceptons les virements bancaires internationaux, les cartes de crédit et, dans certains cas, d'autres modes de paiement."
                    }
                ],
                contactUsText: "Si vous ne trouvez pas la réponse à votre question dans notre Foire aux questions, veuillez nous contacter. Nous vous répondrons bientôt !",
                contactButton: "Contactez-nous",
            },
            support: {
                items: [
                    "Itinéraires personnalisés",
                    "Planification complète",
                    "Orientation d'experts",
                    "Expérience locale",
                    "Support client",
                    "Efforts de durabilité",
                    "Plusieurs régions"
                ]
            }
        }
    },
    footer: {
        pages: {
            title: "Pages",
            settings: "Paramètres",
            profile: "Profil",
            social: "Réseau Social",
        },
        company: {
            title: "Entreprise",
            about: "À propos de nous",
            testimonials: "Témoignages",
            faq: "Foire aux questions",
        },
        support: {
            title: "Assistance",
            contact: "Contactez-nous",
            privacy: "Politique de confidentialité",
            terms: "Termes et Conditions",
            chat: "Assistance par chat",
        },
        services: {
            title: "Services",
            tuktuk: "Tuk Tuk",
            winery: "Vignoble",
            restaurant: "Restaurant",
            car: "Voiture",
            hippotrip: "Hippotrip",
            bike: "Vélo",
        },
        bottom: {
            copyright: "Copyright © 2025. Tous droits réservés,",
            brand: "Portugalwaytour",
            social: [
                { icon: "fa-brands fa-facebook", link: "#" },
                { icon: "fa-brands fa-x-twitter", link: "#" },
                { icon: "fa-brands fa-instagram", link: "#" },
                { icon: "fa-brands fa-linkedin", link: "#" },
                { icon: "fa-brands fa-pinterest", link: "#" },
            ],
            cards: [
                "assets/img/icons/card-01.svg",
                "assets/img/icons/card-02.svg",
                "assets/img/icons/card-03.svg",
                "assets/img/icons/card-04.svg",
                "assets/img/icons/card-05.svg",
                "assets/img/icons/card-06.svg",
            ],
        },
    },

    auth: {
        registerModal: {
            title: "Accédez à votre compte",
            subtitle: "Entrez votre e-mail pour vous connecter ou créer un compte",
            emailLabel: "E-mail",
            emailPlaceholder: "Entrez votre e-mail",
            sendTestCode: "Envoyer le code de test",
            sendEmailCode: "Envoyer le code par e-mail",
            codeLabel: "Code de vérification",
            codePlaceholder: "Entrez le code",
            verifyAndLogin: "Vérifier et se connecter",
            testCodeSuccess: "Code de test '123456' généré. Utilisez-le pour vous connecter.",
            testCodeError: "Erreur lors de la génération du code de test.",
            emailSent: "Code envoyé à votre e-mail !",
            emailError: "Erreur lors de l'envoi du code par e-mail.",
            loginSuccess: "Connexion réussie !",
            invalidCode: "Code invalide ou expiré.",
            or: "Ou",
            google: "Google",
            facebook: "Facebook",
            reminderTitle: "Complétez votre profil",
            reminderText: "N'oubliez pas de compléter votre profil pour profiter de toutes les fonctionnalités de la plateforme !",
            gotIt: "Compris",
        },
    },
    companyRegisterModal: {
        title: "Enregistrement de l'entreprise",
        step1: "Veuillez entrer votre e-mail personnel pour créer un compte administrateur de l'entreprise. Vous utiliserez ce compte pour gérer le profil de l'entreprise.",
        step2: "Nous avons envoyé un code de vérification à votre e-mail. Veuillez l'entrer ci-dessous pour vérifier votre identité.",
        step3: "Maintenant, remplissez les informations de votre entreprise. L'e-mail de l'entreprise doit être un contact professionnel (ex: info@entreprise.com).",

        personalEmail: "Votre e-mail personnel",
        sendTestCode: "Envoyer le code de test",
        sendEmailCode: "Envoyer le code par e-mail",

        verificationCode: "Code de vérification",
        verifyCode: "Vérifier le code",

        companyEmail: "E-mail de l'entreprise",
        companyName: "Nom de l'entreprise",
        nif: "NIF",
        nib: "NIB",
        permanentCertificate: "Numéro du certificat permanent",
        phone: "Téléphone",
        street: "Rue",
        city: "Ville",
        postalCode: "Code postal",
        country: "Pays",
        companyDescription: "Brève description de l'entreprise",
        servicesProvided: "Services offerts",

        contractTitle: "Contrat de l'entreprise",
        acceptContract: "J'accepte le contrat de l'entreprise",
        finishRegistration: "Terminer l'inscription",

        messages: {
            "Test code sent successfully. Use '123456'.": "Code de test envoyé avec succès. Utilisez '123456'.",
            "Verification email sent successfully.": "E-mail de vérification envoyé avec succès.",
            "Verification successful.": "Vérification réussie.",
            "Company registered and contract accepted successfully!": "Entreprise enregistrée et contrat accepté avec succès !",
            testStepMessage: "Code de test envoyé avec succès. Utilisez '123456'.",
            emailStepMessage: "Un code de vérification a été envoyé à votre e-mail. Veuillez l'entrer ci-dessous."
        },

        errors: {
            "Failed to send the verification code.": "Échec de l'envoi du code de vérification.",
            "Invalid or expired code.": "Code invalide ou expiré.",
            "Please fill all required fields.": "Veuillez remplir tous les champs obligatoires.",
            "You must accept the contract to register the company.": "Vous devez accepter le contrat pour enregistrer l'entreprise.",
            "You must be logged in to register the company.": "Vous devez être connecté pour enregistrer l'entreprise.",
            "Failed to register the company or accept the contract.": "Échec de l'enregistrement de l'entreprise ou de l'acceptation du contrat."
        }
    },
    chooseUsSection: {
        title: "Pourquoi nous choisir ?",
        cards: [
            {
                title: "Commodité",
                description: "Planifiez tout votre voyage à partir d'une seule plateforme, économisant du temps et des efforts. Fini les allers-retours entre différents sites web."
            },
            {
                title: "Garantie du meilleur prix",
                description: "Nous travaillons avec des partenaires de voyage fiables pour vous offrir les meilleures offres, que ce soit pour la réservation d'un vol, d'un hôtel ou d'une voiture de location."
            },
            {
                title: "Support client",
                description: "Notre équipe de support dédiée est à votre disposition 24 heures sur 24, 7 jours sur 7, garantissant que vos plans de voyage se déroulent sans problème du début à la fin."
            },
            {
                title: "Expériences de voyage personnalisées",
                description: "Que vous voyagiez pour affaires, en vacances en famille ou pour une aventure en solo, nous proposons des options qui répondent à tous les besoins."
            }
        ]
    },

    contactUsSection: {
        breadcrumb: {
            home: "Accueil",
            pages: "Pages",
            contactUs: "Contact"
        },
        title: "Contactez notre équipe de support dédiée",
        description: "Notre équipe est prête à vous aider. Votre satisfaction est notre priorité.",
        info: [
            {
                label: "Adresse e-mail",
                value: "portugaltourway@gmail.com"
            },
            {
                label: "Numéro de téléphone",
                value: "INSÉRER NUMÉRO"
            },
            {
                label: "Notre emplacement",
                value: "INSÉRER RUE, Almada - Portugal"
            }
        ],
        supportCard: {
            title: "Besoin d'assistance ?",
            textLoggedOut: "Pour contacter notre équipe d'assistance et ouvrir des tickets, vous devez créer un compte ou vous connecter. Après cela, vous aurez un accès complet à votre tableau de bord d'assistance, où vous pourrez suivre et gérer vos demandes.",
            textLoggedIn: "Vous êtes déjà connecté ! Vous pouvez maintenant ouvrir un nouveau ticket d'assistance ou suivre les tickets existants directement depuis votre tableau de bord.",
            btnLoggedOut: "Créer un compte / Se connecter",
            btnLoggedIn: "Ouvrir un ticket sur le tableau de bord"
        }
    },

    sidebar: {
        main: "Principal",
        dashboard: "Tableau de bord",
        myBookings: "Mes réservations",
        myReviews: "Mes évaluations",
        wishlist: "Liste de souhaits",
        support: "Assistance",
        finance: "Finances",
        wallet: "Portefeuille",
        payments: "Paiements",
        account: "Compte",
        myProfile: "Mon profil",
        notifications: "Notifications",
        settings: "Paramètres",
        preferences: "Préférences",
        logout: "Déconnexion",
    },

    agentSidebar: {
        dashboard: "Tableau de bord",
        bookings: "Réservations",
        tukTukBookings: "Réservations de Tuk Tuk",
        hotelBookings: "Réservations d'hôtel",
        carBookings: "Réservations de voiture",
        cruiseBookings: "Réservations de croisière",
        tourBookings: "Réservations de circuits",
        flightBookings: "Réservations de vols",
        enquiries: "Demandes",
        earnings: "Gains",
        reviews: "Évaluations",
        support: "Assistance",
        serviceEnrollment: "Enregistrement des services",
        drivers: "Chauffeurs",
        tukTukVehicles: "Véhicules Tuk Tuk",
        settings: "Paramètres",
        logout: "Déconnexion",
    },

    dashboardCards: {
        totalBookings: "Total des forfaits achetés",
        totalListings: "Total des forfaits",
        totalEarnings: "Total des gains",
        totalReviews: "Total des évaluations",
    },

    recentlyadded: {
        titulo: "Ajouté récemment",
    },

    BookingsStatistics: {
        titulo: "Statistiques de réservation",
        loading: "Chargement des statistiques...",
        none: "Aucune réservation enregistrée pour l'instant.",
    }
};